<template>
    <application-layout
        :property="property"
        :application="application"
        :show-experian-attempts="false"
        :step_completion_status="$page.props.step_completion_status"
        :step_progress_data="$page.props.step_progress_data"
        :completed_steps_map="$page.props.completed_steps_map"
        current-step="share_report"
        sub-title=" - Share Report"
    >
        <share-content 
            :property="property"
            :application="application"
            :is-two-step="isTwoStep"
            :show-repeated-share-failure-nudge="Boolean(show_repeated_share_failure_nudge)"
            :step_completion_status="$page.props.step_completion_status"
            :step_progress_data="$page.props.step_progress_data"
            :completed_steps_map="$page.props.completed_steps_map"
        />
    </application-layout>
</template>

<script>
import ApplicationLayout from './ApplicationLayout.vue';
import ShareContent from './ShareContent.vue';

export default {
    components: {
        ApplicationLayout,
        ShareContent,
    },
    props: {
        property: Object,
        application: Object,
        isTwoStep: Boolean,
        show_repeated_share_failure_nudge: Boolean,
        step_completion_status: Object,
        step_progress_data: Object,
        completed_steps_map: Object,
    },
}
</script>